import { useState } from 'react';
import {
  type ImageDetails,
  ImageInput,
  type ImageInputProps,
} from '../ImageInput';
import { UploadImageButton } from '../UploadImageButton';
import { useImageUrlDetails } from '../hooks';
import { DestinationInputField } from './DestinationInputField';

export interface DestinationImageFieldProps
  extends Pick<ImageInputProps, 'autoFocus' | 'onFocus'> {
  imageDetails?: ImageDetails;
  onChangeImageDetails?: (details: ImageDetails) => void;
}

export const DestinationImageField = ({
  imageDetails,
  onChangeImageDetails,
  autoFocus,
  onFocus,
}: DestinationImageFieldProps) => {
  const [uploadedImageDetails, setUploadedImageDetails] =
    useState<ImageDetails>();
  const [imageDetailsCalculated, status] = useImageUrlDetails(imageDetails);

  const [uploadStatus, setUploadStatus] =
    useState<ImageInputProps['state']>('idle');

  const onUploadLoading = () => {
    setUploadedImageDetails(null);
    setUploadStatus('loading');
  };
  const onUploadError = () => {
    setUploadedImageDetails(null);
    setUploadStatus('error');
  };
  const onUploadSuccess = (image) => {
    setUploadedImageDetails(image);
    onChangeImageDetails?.(image);
    setUploadStatus('idle');
  };

  const value = uploadedImageDetails ?? imageDetailsCalculated;

  return (
    <DestinationInputField
      error={
        (uploadStatus === 'error' &&
          'Image files must be in jpg, jpeg, or png format, and not exceed 10MB.') ||
        (status === 'error' && 'Image type is not supported.')
      }
    >
      <ImageInput
        autoFocus={autoFocus}
        onFocus={onFocus}
        value={value}
        state={status}
        metadata={
          <UploadImageButton
            onUploadLoading={onUploadLoading}
            onUploadError={onUploadError}
            onUploadSuccess={onUploadSuccess}
          />
        }
      />
    </DestinationInputField>
  );
};
